export default __webpack_public_path__ + "static/media/energy_nectar.ed79ec9f.png";